import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { ValueComparisonCardProps } from "../../type";
import { BaseCard } from "./BaseCard";
import { operationsDashboardStyles } from "../../styles";

export const ValueComparisonCard: React.FC<ValueComparisonCardProps> = ({
  data,
}) => {
  return (
    <BaseCard data={data}>
      {data.unit?.includes("%") ? (
        <Typography
          sx={operationsDashboardStyles.valueText}
        >{`${data.value}${data.unit}`}</Typography>
      ) : (
        <Box sx={operationsDashboardStyles.flexCenter}>
          <Typography sx={operationsDashboardStyles.unitText}>
            {data.unit ?? ""}
          </Typography>
          <Typography sx={operationsDashboardStyles.valueText}>
            {data.value}
          </Typography>
        </Box>
      )}

      {data.comparison && (
        <Box sx={operationsDashboardStyles.bottomSection}>
          <Stack direction="row" sx={operationsDashboardStyles.bottomStack}>
            {data.comparison && (
              <Box sx={operationsDashboardStyles.comparisonContainer}>
                <Typography sx={operationsDashboardStyles.comparisonLabel}>
                  {data.comparison.label}
                </Typography>
              </Box>
            )}
          </Stack>
        </Box>
      )}
    </BaseCard>
  );
};
